import {defineStore} from 'pinia';
import {ref, computed} from 'vue';

export const useSupportChatStore = defineStore('supportChatStore', () => {
    const isChatOpen = ref<boolean>(false);

    function openChat() {
        isChatOpen.value = true;
    }

    function closeChat() {
        isChatOpen.value = false;
    }

    function toggleChat() {
        isChatOpen.value = !isChatOpen.value;
    }

    return {
        isChatOpen: computed(() => isChatOpen.value),
        openChat,
        closeChat,
        toggleChat
    };
});